
import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import releaseNotes from '../../data/release-notes.json';

const ReleaseNoteDetail = () => {
  const { id } = useParams();
  const note = releaseNotes.find(n => n.id === id);

  useEffect(() => {
    if (note) {
      document.title = `${note.title} | BillWave リリースノート`;
    }
    return () => {
      document.title = 'BillWave';
    };
  }, [note]);

  if (!note) {
    return (
      <div className="max-w-4xl mx-auto mt-8">
        <div className="bg-white p-8 shadow-sm rounded-lg text-center">
          <h1 className="text-2xl font-bold mb-4 text-gray-800">記事が見つかりません</h1>
          <p className="mb-8 text-gray-600">指定されたリリースノートは存在しないか、削除された可能性があります。</p>
          <Link to="/app/release-notes" className="text-blue-600 hover:underline">
            リリースノート一覧へ
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto mt-4">
      {/* 戻るリンク - 控えめに配置 */}
      <div className="mb-4">
        <Link to="/app/release-notes" className="text-sm font-medium text-blue-600 hover:text-blue-500 flex items-center">
          <svg className="mr-1 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
          </svg>
          リリースノート一覧
        </Link>
      </div>

      <div className="bg-white shadow-sm rounded-lg p-8 sm:p-12 min-h-[600px]">
        {/* メインタイトル - CSVフォーマットページに準拠 */}
        <h1 className="text-4xl font-extrabold text-gray-900 mb-8 pb-6 border-b border-gray-200 leading-tight">
          {note.title}
        </h1>

        <div className="flex items-center text-sm text-gray-500 mb-10">
          <span className="bg-gray-100 px-3 py-1 rounded-full font-mono">
            {note.publishedAt.replace(/-/g, '/')}
          </span>
          <span className="ml-3">配信</span>
        </div>

        <div className="prose prose-lg max-w-none text-gray-800">
          <p className="whitespace-pre-wrap leading-relaxed text-lg font-normal">
            {note.body}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReleaseNoteDetail;
